import Rest from '../Rest'

export default class OrganizationalUnitService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/organizational_units'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
